import {SET_PNR,SET_PASSENGER_DATA,SET_ITINARY_FARE,SET_SEGMENT,SET_BOOKING_DETAIL,SET_TOTAL_SELLING_PRICE, SET_BOOKING_PAYMENT_STATUS, SET_ITINARY_FARES_TYPE,
     SET_BOOKING_DATE,SET_BOOKING_STATUS,PRICE_STATUS, SET_PNR_CANCELLATION_STATUS, SET_CANCELLATION_POPUP,SET_BRANDED_ITINARY_FARE,SET_SEATMAP_HEADER, 
     SET_PASSENGER_DETAILS_ARRAY, SET_BOOK_WITH_PAYMENT_FLAG,SET_PNR_PRICE,SET_BRANDED_STATUS,SET_SEARCH_STATUS,SET_PAYMENT_RULES, SET_MARKUP_STATUS,
    SET_ADULT_COUNT,SET_CHILDREN_COUNT,SET_INFANT_COUNT,
    SET_MYFILE_FLAG,
    SET_PASSENGER_FRAUD_LIST, SET_FRAUD_USER_EXISTS, SET_FRAUD_USER_EXISTS_WITH_PAYMENT, SET_FRAUD_USER_FLAG, SET_PAYMENT_RULES_FOR_CHEQUE, SET_CREATE_BOOKING_DATA, SET_PRICING_FARE_DATA, SET_SSR_LOADER_FLAG, SET_SSR_SAVE_EDIT_FLAG,SET_APPLY_BUTTON_CLICK_FLAG, SET_LAND_CRUISE_BOOKING_NUMBER, SET_AGENT_EMERGENCY_NUMBER, SET_VALIDATION_ON_LAND_CRUISE, SET_EQUIVALENT_FARE_VALUE, SET_EQUIVALENT_FARE_LOADER, SET_REPRICE_FARE, SET_REPRICE_FARE_LOADER, SET_FREQUENT_FLYER_DROPDOWN, SET_GET_PNR_RESULT, SET_BOOKING_STATUS_CODE, SET_FARE_PAYMENT_ATTEMPT, SET_SEAT_PAYMENT_ATTEMPT, SET_FARE_PAYMENT_STATUS, SET_SEAT_PAYMENT_STATUS, SET_FOP_SELECTION, SET_EMAIL_LANGUAGE, SET_MARKUP_LOADER, SET_FLOW_FROM, SET_CALC_ERRORS, SET_EXISTING_FARE_REMARK_CHECK, SET_TRIPTYPE_FLOW_FROM, SET_REPRICE_PNR_RADIO_BUTTON, SET_SELECTED_BRANDED_FARE, SET_MARKUP_BUTTON_CHECK, SET_MARKUP_BUTTON_COUNT, SET_LAND_CRUISE_BOOKING_NUMBER_CHECK, SET_DISABLE_SAVE_BUTTON, ALLOW_SEAT_PAYMENT, OPEN_QUOTE_DIALOG, SET_AUTO_REPRICE, SET_PAX_TYPE_CODE_ERROR_FLAG, SET_CANCELLATION_STATUS, SET_CANCELLATION_CONFIRMATION, SET_REGULAR_REFUND_CANCELLATION_DETAILS, SET_PROVIDER_TYPE, SET_UPDATE_PNR_CALCULATOR_FLOW, SET_OFFERID_TIMEOUT, SET_EXPIRE_TIME, SET_SEND_AUTO_EMAIL, SET_PASSENGER_INFO_FOR_LATER_PAY, SET_APPLY_MARKUP_BUTTON, SET_CANCELLATION_BOOKING_CODE, SET_SAVE_BUTTON_LOADER, SET_APPLY_MARKUP_POPUP, SET_INITIAL_ITINERARY_FARE, SET_INITIAL_PAYMENT_RULES, SET_UNSAVED_CHANGES_FLAG, SET_INITIAL_PAYMENT_RULES_CHQ, SET_ENABLE_BRANDED_FARES, SET_ENABLE_PER_PASSENGER, SET_OUTBOUND_BRAND_CODES, SET_INBOUND_BRAND_CODES, SET_OUTBOUND_BRAND_CODE_PER_PASSENGERS, SET_INBOUND_BRAND_CODE_PER_PASSENGERS, SET_VALIDATING_CARRIER, SET_BRANDCODE_OUT_DROPDOWN, SET_SAVE_CALCULATOR_FLOW, SET_REPRICE_FLAG, SET_BRANDCODE_IN_DROPDOWN, SET_REPRICE_LOADER, SET_OUTBOUND_OPTION, SET_INBOUND_OPTION, SET_PREVIOUS_VC, SET_ISNONGIGI_PNR, SET_IS_UNACCOMPANIED_MINOR, SET_RESET_CALC_DATA, SET_IS_ITINERARY_CHANGED, SET_AUTO_EMAIL_TYPE, SET_IS_RETRY_REQUEST_ERROR, SET_UPDATE_BOOKING_STATUS_POP_UP, 
    SET_PROVIDER_NAME, SET_SHOW_CALCULATOR, SET_SHOW_CALCULATOR_MSG, 
    SET_BAGGAGE_CHANGE,
    SET_PAYMENT_RULES_FOR_NON_ACCEPTED_CC,
    SET_MERCHANT_FEE_FOR_NON_ACCEPTED_CC,
    SET_INITIAL_NERCHANT_FEE,
    SET_BAGGAGE_CHANGE_MSG,
    SET_ALL_PASSENGER_DETAILS,
    SET_PRICE_INCREASE_ERROR,
    SET_REPRICE_ATTEMPT,
    SET_PAYMENT_ERROR_MSG,
    SET_ISBWP_FLOW
} from '../storeConstants';
   
export const setPnr = (pnr) => {
    return {
        type: SET_PNR,
        payload: pnr
    }
}

export const setRegularRefundCancellationDetails = (obj) => {
   return {
       type: SET_REGULAR_REFUND_CANCELLATION_DETAILS,
       payload: obj
   }
}

export const setSegment = (value) => {
    return {
        type: SET_SEGMENT,
        payload: value
    }
}

export const setItenaryData = (value) => {
    
    return {
        type: SET_ITINARY_FARE,
        payload: value
    }
}

export const setPassengerData = (value) => {
    return {
        type: SET_PASSENGER_DATA,
        payload: value
    }
}

export const setBookingDetails = (value) => {
    return {
        type: SET_BOOKING_DETAIL,
        payload: value
    }
}

export const setTotalSellingPrice = (value) => {
    return {
        type: SET_TOTAL_SELLING_PRICE,
        payload: value
    }
}

export const setBookingPaymentPaymentStatus = (value) => {
    return {
        type: SET_BOOKING_PAYMENT_STATUS,
        payload: value
    }
}


export const setItinaryFaresType = (value) => {
    return {
        type: SET_ITINARY_FARES_TYPE,
        payload: value
    }
}


export const setBookingDate = (value) => {
    return {
        type: SET_BOOKING_DATE,
        payload: value
    }
}

export const setBookingStatus=(value)=>{
    return{
        type:SET_BOOKING_STATUS,
        payload:value
    }
}

export const setSuccessPrice=(value)=>{
    return{
        type:PRICE_STATUS,
        payload:value
    }
}

export const setPnrCancellationStatus =(value)=>{
    return{
        type:SET_PNR_CANCELLATION_STATUS,
        payload:value
    }
}

export const setCancellationStatus =(value)=>{
    return{
        type:SET_CANCELLATION_STATUS,
        payload:value
    }
}
export const setCancellationConfirmation =(value)=>{
    return{
        type:SET_CANCELLATION_CONFIRMATION,
        payload:value
    }
}

export const setCancellationPopUp =(value)=>{
    return{
        type:SET_CANCELLATION_POPUP,
        payload:value
    }
}

export const setPassengerDetailsArray =(value)=>{
    return{
        type:SET_PASSENGER_DETAILS_ARRAY,
        payload:value
    }
}

export const setBookWithPaymentFlag =(value)=>{
    return{
        type:SET_BOOK_WITH_PAYMENT_FLAG,
        payload:value
    }
}


export const setBrandedItenaryData = (value) => {
    return {
        type: SET_BRANDED_ITINARY_FARE,
        payload: value
    }
}

export const setSeatMapHeader = (value) => {
    return {
        type: SET_SEATMAP_HEADER,
        payload: value
    }
}

export const setPnrPrice = (result) => {
    return {
        type: SET_PNR_PRICE,
        payload: result
    }
}

export const setBrandedStatus = (from) => {
    return {
        type: SET_BRANDED_STATUS,
        payload: from
    }
}

export const setSearchStatus = (from) => {
    return {
        type: SET_SEARCH_STATUS,
        payload: from
    }
}

export const setPaymentRules = (from) => {
    return {
        type: SET_PAYMENT_RULES,
        payload: from
    }
}
export const setPaymentRulesForCheque = (from) => {
    return {
        type: SET_PAYMENT_RULES_FOR_CHEQUE,
        payload: from
    }
}

export const setMarkupApplied = (from) => {
    return {
        type: SET_MARKUP_STATUS,
        payload: from
    }
}


export const setPassengerFraudList = (passenger) => {
    return {
        type: SET_PASSENGER_FRAUD_LIST,
        payload: passenger
    }
}

export const setFraudUserExists = (value) => {
    return {
        type: SET_FRAUD_USER_EXISTS,
        payload: value
    }
}

export const setFraudUserExistsWithPayment = (value) => {
    return {
        type: SET_FRAUD_USER_EXISTS_WITH_PAYMENT,
        payload: value
    }
}

export const setFraudUserFlag = (value) => {
    return {
        type: SET_FRAUD_USER_FLAG,
        payload: value
    }
}

export const setAdultCount = (adultCount) => {
    return {
        type: SET_ADULT_COUNT,
        payload: adultCount
    }
}

export const setChildrenCount = (childrenCount) => {
    return {
        type: SET_CHILDREN_COUNT,
        payload: childrenCount
    }
}

export const setInfantCount = (infantCount) => {
    return {
        type: SET_INFANT_COUNT,
        payload: infantCount
    }
}

export const setMyfilesFlag = (flag) => {
    return {
        type: SET_MYFILE_FLAG,
        payload: flag
    }
}

export const setCreateBookingData = (pnr) => {
    return {
        type: SET_CREATE_BOOKING_DATA,
        payload: pnr
    }
}

export const setPricingFareData = (pnr) => {
    return {
        type: SET_PRICING_FARE_DATA,
        payload: pnr
    }
}
export const setSsrLoaderFlag = (pnr) => {
    return {
        type: SET_SSR_LOADER_FLAG,
        payload: pnr
    }
}

export const setSsrSaveEditFlag = (pnr) => {
    return {
        type: SET_SSR_SAVE_EDIT_FLAG,
        payload: pnr
    }
}
export const setApplyButtonClickFlag = (pnr) => {
    return {
        type: SET_APPLY_BUTTON_CLICK_FLAG,
        payload: pnr
    }
}
export const setLandCruiseBookingNumber = (pnr) => {
    return {
        type: SET_LAND_CRUISE_BOOKING_NUMBER,
        payload: pnr
    }
}
export const setAgentEmergencyNumber = (pnr) => {
    return {
        type: SET_AGENT_EMERGENCY_NUMBER,
        payload: pnr
    }
}
export const setValidationOnLandCruise = (pnr) => {
    return {
        type: SET_VALIDATION_ON_LAND_CRUISE,
        payload: pnr
    }
}
export const setEquivalentFareValue = (value) => {
    return {
        type: SET_EQUIVALENT_FARE_VALUE,
        payload: value
    }
}
export const setEquivalentFareLoader = (value) => {
    return {
        type: SET_EQUIVALENT_FARE_LOADER,
        payload: value
    }
}
export const setRepriceFare = (value) => {
    return {
        type: SET_REPRICE_FARE,
        payload: value
    }
}

export const setRepriceFareLoader = (value) => {
    return {
        type: SET_REPRICE_FARE_LOADER,
        payload: value
    }
}

export const setFrequentFlyerDropdown = (value) => {
    return {
        type: SET_FREQUENT_FLYER_DROPDOWN,
        payload: value
    }
}

export const setGetPnrResult = (value) => {
    return {
        type: SET_GET_PNR_RESULT,
        payload: value
    }
}

export const setBookingStatusCode = (value) => {
    return {
        type: SET_BOOKING_STATUS_CODE,
        payload: value
    }
}

export const setFarePaymentAttempt = (value) => {
    return {
        type: SET_FARE_PAYMENT_ATTEMPT,
        payload: value
    }
}

export const setSeatPaymentAttempt = (value) => {
    return {
        type: SET_SEAT_PAYMENT_ATTEMPT,
        payload: value
    }
}

export const setFarePaymentStatus = (value) => {
    return {
        type: SET_FARE_PAYMENT_STATUS,
        payload: value
    }
}

export const setSeatPaymentStatus = (value) => {
    return {
        type: SET_SEAT_PAYMENT_STATUS,
        payload: value
    }
}
export const setFopSelection = (value) => {
    return {
        type: SET_FOP_SELECTION,
        payload: value
    }
}
export const setEmailLanguage = (value) => {
    return {
        type: SET_EMAIL_LANGUAGE,
        payload: value
    }
}
export const setMarkupLoader = (value) => {
    return {
        type: SET_MARKUP_LOADER,
        payload: value
    }
}

export const setFlowFrom = (value) => {
    return {
        type: SET_FLOW_FROM,
        payload: value
    }
}

export const setCalcErrors = (value) => {
    return {
        type: SET_CALC_ERRORS,
        payload: value
    }
}

export const setExistingFareRemarkCheck = (value) => {
    return {
        type: SET_EXISTING_FARE_REMARK_CHECK,
        payload: value
    }
}

export const setTripTypeFlowFrom = (value) => {
    return {
        type: SET_TRIPTYPE_FLOW_FROM,
        payload: value
    }
}

export const setRepricePnrRadioButton = (value) => {
    return {
        type: SET_REPRICE_PNR_RADIO_BUTTON,
        payload: value
    }
}

export const setSelectedBrandedFare = (value) => {
    return {
        type: SET_SELECTED_BRANDED_FARE,
        payload: value
    }
}

export const setMarkupButtonCheck = (value) => {
    return {
        type: SET_MARKUP_BUTTON_CHECK,
        payload: value
    }
}

export const setMarkupButtonCount = (value) => {
    return {
        type: SET_MARKUP_BUTTON_COUNT,
        payload: value
    }
}

export const setLandCruiseBookingNumberCheck = (value) => {
    return {
        type: SET_LAND_CRUISE_BOOKING_NUMBER_CHECK,
        payload: value
    }
}

export const setDisableSaveButton = (value) =>{
    return {
        type: SET_DISABLE_SAVE_BUTTON,
        payload: value
    }
}

export const setAllowSeatPayment = (value) => {
    return {
        type : ALLOW_SEAT_PAYMENT,
        payload: value
    }
}

export const setOpenQuoteDialog = (value) => {
    return {
        type: OPEN_QUOTE_DIALOG,
        payload: value
    }
}

export const setAutoReprice = (value) => {
    return {
        type: SET_AUTO_REPRICE,
        payload: value
    }
}

export const setPaxTypeCodeErrorFlag = (value) => {
    return {
        type: SET_PAX_TYPE_CODE_ERROR_FLAG,
        payload: value
    }
}

export const setProviderType = (value) => {
   return {
       type: SET_PROVIDER_TYPE,
       payload: value
   }
}

export const setOfferIdTimeout = (value)=>{
    return{
        type: SET_OFFERID_TIMEOUT,
        payload: value
    }
}

export const setExpireTime = (value)=>{
    return{
        type: SET_EXPIRE_TIME,
        payload: value
    }
}

export const setSendAutoEmail = (value)=>{
    return{
        type: SET_SEND_AUTO_EMAIL,
        payload: value
    }
}

export const setPassengerInfoForLaterPay = (value)=>{
    return{
        type: SET_PASSENGER_INFO_FOR_LATER_PAY,
        payload: value
    }
}

export const setApplyMarkupButton = (value)=>{
    return{
        type: SET_APPLY_MARKUP_BUTTON,
        payload: value
    }
}

export const setCancellationBookingCode =(value)=>{
    return{
        type:SET_CANCELLATION_BOOKING_CODE,
        payload:value
    }
}

export const setSaveButtonLoader =(value)=>{
    return{
        type:SET_SAVE_BUTTON_LOADER,
        payload:value
    }
}

export const setMarkupPopUp = (value)=>{
    return{
        type: SET_APPLY_MARKUP_POPUP,
        payload: value
    }
}

export const setInitialItineraryFare = (value)=>{
    return{
        type: SET_INITIAL_ITINERARY_FARE,
        payload: value
    }
}

export const setInitialPaymentRules = (value)=>{
    return{
        type: SET_INITIAL_PAYMENT_RULES,
        payload: value
    }
}

export const setUnSavedChangesInMarkupFlag = (value)=>{
    return{
        type: SET_UNSAVED_CHANGES_FLAG,
        payload: value
    }
}

export const setInitialPaymentRulesChq = (value)=>{
    return{
        type: SET_INITIAL_PAYMENT_RULES_CHQ,
        payload: value
    
    }
}
export const setUpdatePnrCalculatorFlow = (value) => {
    return {
        type: SET_UPDATE_PNR_CALCULATOR_FLOW,
    }
}

export const setEnableBrandedFare = (value)=>{
    return{
        type: SET_ENABLE_BRANDED_FARES,
        payload: value
    }
}

export const setEnablePerPassengers = (value)=>{
    return{
        type: SET_ENABLE_PER_PASSENGER,
        payload: value
    }
}

export const setOutboundBrandCodes = (value)=>{
    return{
        type: SET_OUTBOUND_BRAND_CODES,
        payload: value
    }
}
export const setInboundBrandCodes = (value)=>{
    return{
        type: SET_INBOUND_BRAND_CODES,
        payload: value
    }
}
export const setOutboundBrandCodePerPassengers = (value)=>{
    return{
        type: SET_OUTBOUND_BRAND_CODE_PER_PASSENGERS,
        payload: value
    }
}
export const setInBoundBrandCodePerPassengers = (value)=>{
    return{
        type: SET_INBOUND_BRAND_CODE_PER_PASSENGERS,
        payload: value
    }
}

export const setValidatingCarrier = (value)=>{
    return{
        type: SET_VALIDATING_CARRIER,
        payload: value
    }
}

export const setBrandCodeOutDropdown = (value)=>{
    return{
        type: SET_BRANDCODE_OUT_DROPDOWN,
        payload: value
    }
}

export const setSaveCalculatorFlow = (value) => {
    return {
        type: SET_SAVE_CALCULATOR_FLOW,
        payload: value
    }
}

export const setRepriceFlag = (value) => {
    return {
        type: SET_REPRICE_FLAG,
        payload : value
    }
}

export const setBrandCodeInDropdown = (value)=>{
    return{
        type: SET_BRANDCODE_IN_DROPDOWN,
        payload: value
    }
}

export const setRepriceLoader = (value)=>{
    return{
        type: SET_REPRICE_LOADER,
        payload: value
    }
}

export const setOutboundOption = (value)=>{
    return{
        type: SET_OUTBOUND_OPTION,
        payload: value
    }
}

export const setInboundOption = (value)=>{
    return{
        type: SET_INBOUND_OPTION,
        payload: value
    }
}

export const setPreviousVC = (value)=>{
    return{
        type: SET_PREVIOUS_VC,
        payload: value
    }
}

export const setNonGigiPNR = (value)=>{
    return{
        type: SET_ISNONGIGI_PNR,
        payload: value
    }
}

export const setIsUnaccompaniedMinor = (value)=>{
    return{
        type: SET_IS_UNACCOMPANIED_MINOR,
        payload: value
    }
}

export const setResetCalcData = (value) =>{
    return {
        type: SET_RESET_CALC_DATA,
        payload: value
    }
}

export const setIsItineraryChanged = (value)=>{
    return {
        type: SET_IS_ITINERARY_CHANGED,
        payload:value
    }
}

export const setAutoEmailType = (value)=>{
    return{
        type: SET_AUTO_EMAIL_TYPE,
        payload: value
    }
}

export const setIsRetryRequestError = (value)=>{
    return{
        type: SET_IS_RETRY_REQUEST_ERROR,
        payload: value
    }
}

export const setUpdateBookingStatusPopUp = (value)=>{
    return{
        type: SET_UPDATE_BOOKING_STATUS_POP_UP,
        payload: value
    }
}

export const setProviderName = (value) => {
    return{
        type:SET_PROVIDER_NAME,
        payload:value
    }
}

export const setShowCalculator = (value)=>{
    return {
        type: SET_SHOW_CALCULATOR,
        payload: value
    }
}

export const setShowCalculatorMsg = (value)=>{
    return {
        type: SET_SHOW_CALCULATOR_MSG,
        payload: value
    }
}

export const setBaggageChange = (value) => {
    return {
        type: SET_BAGGAGE_CHANGE,
        payload: value
    }
}

export const setPaymentRulesForNonAcceptedCC = (value) => {
    return {
        type: SET_PAYMENT_RULES_FOR_NON_ACCEPTED_CC,
        payload: value
    }
}

export const setMerchantFeeForNonAcceptedCC = (value) => {
    return {
        type: SET_MERCHANT_FEE_FOR_NON_ACCEPTED_CC,
        payload: value
    }
}

export const setInitialMerchantFee = (value) => {
    return {
        type: SET_INITIAL_NERCHANT_FEE,
        payload: value
    }
}

export const setBaggageChangeMsg = (value) => {
    return {
        type: SET_BAGGAGE_CHANGE_MSG,
        payload: value
    }
}

export const setAllPassengerDetails = (value) => {
    return {
        type: SET_ALL_PASSENGER_DETAILS,
        payload: value
    }
}

export const setPriceIncreaseError = (value) => {
    return {
        type: SET_PRICE_INCREASE_ERROR,
        payload: value
    }
}

export const setRepriceAttempt = (value) => {
    return {
        type: SET_REPRICE_ATTEMPT,
        payload: value
    }
}

export const setPaymentErrorMsg = (value) => {
    return {
        type: SET_PAYMENT_ERROR_MSG,
        payload: value
    }
}

export const setIsBWPFlow = (value) => {
    return {
        type: SET_ISBWP_FLOW,
        payload: value
    }
}